import { NewsResponse } from '@wwe-portal/entities/news.type';
import { nestApiClient } from './api-client';

export const getNews = (params: { skip: number; limit: number }) =>
  nestApiClient.get<NewsResponse>('/news/v3', {
    params,
  });
